import { Component, OnInit } from '@angular/core';
import { AngularFireStorageReference, AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { Blobs } from 'my-lib-sanfelici';
import { UrlService } from 'my-lib-sanfelici';
import { BlobService } from 'my-lib-sanfelici';
import { Marchio } from 'my-lib-sanfelici';

@Component({
  selector: 'app-marchi-uplodad',
  templateUrl: './marchi-uplodad.component.html',
  styleUrls: ['./marchi-uplodad.component.scss']
})
export class MarchiUplodadComponent implements OnInit {
  file: File;
  name: string;
  ref: AngularFireStorageReference;
  url: string;
  uploadPercent: Observable<number>;
  blobs: Blobs;
  id: string;
  constructor(
    private db: AngularFirestore,
    private storage: AngularFireStorage,
    private route: ActivatedRoute,
    private urlservice: UrlService,
    private router: Router,
    private blobsservice: BlobService
  ) {
    this.urlservice.url$.subscribe(u => {
      this.url = u;
      console.log(u);
    });
   }
  uploadFile(event) {
    this.file = event.target.files[0];
    this.name = this.file.name;
    this.ref = this.storage.ref(`${this.router.routerState.snapshot.url + '/' + this.name}`);
  }
  storedBlob() {
    // Start the upload

    const task = this.storage.upload(`${this.router.routerState.snapshot.url + '/' + this.name}`, this.file);
    this.uploadPercent = task.percentageChanges();
    task.then(m => {
      const meta = this.ref.getMetadata();
      const downloadURL = this.ref.getDownloadURL();
      downloadURL.subscribe(url => {
        meta.subscribe( m => {         
          this.blobs = {bucket: m.bucket,
                fullPath : m.fullPath,
                id: this.id,
                name : m.name,
                size : m.size,
                refFirestore:this.db.collection<Marchio>('marchi')
                .doc<Marchio>(this.id)
                .collection<Blobs>('blobs')
                .doc<Blobs>(this.name).ref,                
                type:'marchi',
                downloadURL: url,
                updated : new Date( m.updated),
                timeCreated : new Date( m.timeCreated),
                contentType : m.contentType};
                this.blobs.refFirestore
          .set(this.blobs,{merge:true});
        });
      });

    });

    }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
  }

}
